import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import IconButton from '@widget/buttons/IconButton';
import MediaPreview from './MediaPreview';
import { mediaValueName } from './mediaLibrary';
/**
 * @export
 * The detail column of the media picker: a back chevron out of the preview, the
 * value's name, a large preview of it and whatever controls the source
 * contributes.
 */
const MediaPreviewPanel = (props) => {
    const { value, name, children, selected, onToggle, onClose, closeTitle, notice } = props;
    if (!value)
        return null;
    return _jsx("div", { className: "uxpcore_mediapicker__preview", children: _jsxs("div", { className: "uxpcore_mediapicker__preview-inner", children: [_jsxs("div", { className: "uxpcore_mediapicker__preview-titlerow", children: [onClose &&
                            _jsx("span", { className: "uxpcore_mediapicker__preview-back", children: _jsx(IconButton, { icon: "fal chevron-left", borderless: true, tooltip: closeTitle, onClick: onClose }) }), _jsx("div", { className: "uxpcore_mediapicker__preview-title", children: name || mediaValueName(value) })] }), notice && _jsx("div", { className: "uxpcore_mediapicker__preview-notice", children: notice }), _jsxs("div", { className: classNames('uxpcore_mediapicker__preview-body', {
                        'uxpcore_mediapicker__preview-body--selectable': !!onToggle,
                    }), onClick: onToggle, children: [_jsx(MediaPreview, { value: value, name: name }), selected &&
                            _jsx("div", { className: "uxpcore_mediapicker__item-check", children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'check'] }) })] }), children &&
                    _jsx("div", { className: "uxpcore_mediapicker__preview-extra", children: children })] }) });
};
export default MediaPreviewPanel;
